import * as React from 'react';
import { Component } from 'react';
import { Radio } from 'antd';
import intl from 'react-intl-universal';
import './index.scss';

export default class Security extends Component {
  static storeKey() {
    return 'SECURITY_PROTECTED_VIEW';
  }

  constructor(props) {
    super(props);
    const mode = localStorage.getItem(Security.storeKey()) || 'off';
    this.state = {
      mode,
    };
  }

  handleViewMode = (e) => {
    const { value } = e.target;
    this.setState({
      mode: value,
    });
    window.pdfui.eventEmitter.emit('setSecurityModeEvt',value);
  };

  render() {
    const Title = intl.formatMessage({ id: 'Preferences.Content.Security.Title' });
    const Off = intl.formatMessage({ id: 'Preferences.Content.Security.Off' });
    const AllFile = intl.formatMessage({ id: 'Preferences.Content.Security.AllFile' });

    return (
      <div className="per-security-panel">
        <div className="title">{Title}</div>
        <div className="LayoutGrid">
          <Radio.Group onChange={(e) => this.handleViewMode(e)} value={this.state.mode}>
            <Radio value="off">{Off}</Radio>
            <Radio value="all">{AllFile}</Radio>
          </Radio.Group>
        </div>
      </div>
    );
  }
}
